import { render, staticRenderFns } from "./AdminRevenue.vue?vue&type=template&id=04d50e2f&"
import script from "./AdminRevenue.vue?vue&type=script&lang=js&"
export * from "./AdminRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports